module.exports = __webpack_public_path__ + "static/media/Latanya B.80858f05.png";